'use strict';

angular.module('shiftTraderPrintApp')
  .controller('DeploymentSheetCtrl', function ($scope, $window, $interval, $rootScope, $location, $state, $uibModal,
                                             TimeService, WorkPeriods, WorkPeriodStore, AvailabilityRules, Organizations,
                                             me, theDate, allPositions, allWorkPeriods, allUsers, org, Session,
                                             UserPermissionsService) {

    var NUM_COLS_IN_ROW = 4;

    //console.log('loading DeploymentSheetCtrl', moment().format('ss SSS'));
    $scope.me = me;
    $scope.allPositions = _.map(allPositions, function(pos) {
      if (_.isUndefined(pos.department_id)) {
        pos.department_id = null;
      }
      return pos;
    });
    $scope.org = org;
    $scope.allWorkPeriods = _.where(allWorkPeriods, function(wp) {
      return wp.active && wp.$isAssigned();
    });

    var positionIdsToShow = _.uniq(_.flatten(
        [_.pluck(allWorkPeriods, 'position_id'),
          _.pluck(_.where($scope.allPositions, {active: true}), 'id')]
    ));

    $scope.positionsToShow = _.where($scope.allPositions, function(pos) {
      return _.contains(positionIdsToShow, pos.id);
    });


    $scope.allUsers = _.where(allUsers, function(u) {
      return u.memberships[0].active;
    });

    $scope.nowTime = TimeService.getNowInStoreTime();
    $scope.currentDate = theDate;
    $scope.currentTwix = moment(theDate).twix(moment(theDate).add(1, 'days'));

    $scope.printScreen = function() {
      $window.print();
    };

    $scope.miniOrg = Organizations.initWithData($scope.me.memberships[0].organization);
    $scope.orgPictureUrl = $scope.miniOrg.$hasCustomLogo() ? $scope.miniOrg.logo_urls.medium :
        "https://d327l0dy67qzb.cloudfront.net/landing/images/Shift-Agent-ICON-300px.png";

    $scope.showNoDepartmentArea = _.any($scope.positionsToShow, {department_id: null});


    $scope.orgPictureUrl = $scope.org.$hasCustomLogo() ? $scope.org.logo_urls.medium :
        "https://d327l0dy67qzb.cloudfront.net/landing/images/Shift-Agent-ICON-300px.png";
    $scope.departments = _.map($scope.org.departments, function(dept) {
      dept.positions = [];
      return dept;
    });
    if (_.any($scope.positionsToShow, {department_id: null}) && !_.any($scope.departments, {id: null})) {
      $scope.departments.push({
        id: null,
        name: 'Uncategorized'
      });
    }


    $scope.workPeriodsByPositionId = {};

    _.forEach($scope.positionsToShow, function(pos) {
      //console.log(pos.name, pos.id);
      var deptIdx = _.findIndex($scope.departments, {id: pos.department_id});
      if (deptIdx > -1) {
        if (!_.has($scope.departments[deptIdx], 'positions')) {
          $scope.departments[deptIdx].positions = [];
        }
        $scope.departments[deptIdx].positions.push(pos);

      }

      $scope.workPeriodsByPositionId[pos.id] = [];
      var match = _.find($scope.departments, {id: pos.department_id});
      if (!_.isUndefined(match)) {
        if (!_.has(match, '_position_ids')) {
          match._position_ids = [];
        }

        match._position_ids.push(pos.id);
      }
    });

    $scope.filteredPositions = $scope.positionsToShow;

    var processDayOff = function(dayOff) {
      var intersection = $scope.currentTwix.intersection(dayOff.range_twix);

      if (intersection.equals($scope.currentTwix)) {
        dayOff._stringLabel = 'All Day';
      } else {
        dayOff._stringLabel = TimeService.minimalIntervalTimeFormat(intersection).strings.interval;
      }

      return dayOff;
    };

    function getDaysOff() {
      var availabilityStartDate = moment($scope.currentDate).subtract(1, 'days');
      var availabilityEndDate = moment($scope.currentDate).add(2, 'days');
      AvailabilityRules.getAll({
        type: 'daysoff',
        active: true,
        status: 'approved',
        start_date: availabilityStartDate.format('YYYY-MM-DD'),
        end_date: availabilityEndDate.format('YYYY-MM-DD')
      })
          .then(function(rules) {
            $scope.approvedDaysOff = _.map(_.where(rules, function(dayoff) {
              var relatedUser = _.find($scope.allUsers, {id: dayoff.user_id});

              return dayoff.range_twix.overlaps($scope.currentTwix) &&
                       Math.abs(dayoff.range_twix.intersection($scope.currentTwix).length('minutes')) > 0 &&
                       !_.isUndefined(relatedUser);
            }), processDayOff);

          }, function() {
            console.log('issue fetching availability data');
          });

    }

    $scope.settings = {
      showUnpublished: _.isUndefined(($location.search()).showUnpublished) ? false : ($location.search()).showUnpublished === 'true',
      autoRefresh: false,
      autoRefreshFaster: false,
      selectedDepartment: -1,
      autoRefreshFasterTimer: 0,
      showApprovedDaysOff: false,
      printPortrait: false,
      showPageOrientation: true
    };

    if (Session.getPrintSettings() && Session.getPrintSettings()['deployment'] && !_.isEmpty(Session.getPrintSettings()['deployment'])) {
      $scope.settings = _.extend($scope.settings, Session.getPrintSettings()['deployment']);
    }

    $scope.beginningOfWeek = TimeService.getWeekTwixFromMoment(theDate, 0, 0).start;
    $scope.dateRangesInWeek = _.map(_.range(0,7), function(num) {
      return moment($scope.beginningOfWeek).add(num, 'days')
        .twix(moment($scope.beginningOfWeek).add(num + 1, 'days'));
    });


    $scope.state = {
      rawPermissions: null,
      derivedPermissions: null
    };

    if ($scope.settings.printPortrait) {
      NUM_COLS_IN_ROW = 3;
      $('.standard_print_container').removeClass('landscape');
      $('.standard_print_container').addClass('portrait');
    } else {
      NUM_COLS_IN_ROW = 4;
      $('.standard_print_container').addClass('landscape');
      $('.standard_print_container').removeClass('portrait');
    }



    function processRawPermissions() {
      var rawPerm = $scope.state.rawPermissions;

      $scope.state.derivedPermissions = {
        canShowUnpublished: rawPerm['work_periods.view_unpublished'],
        canShowDaysOff: rawPerm['availability_rules.view_in_org'],
        canAutoReloadPage: rawPerm['ui.scheduling.view_timeline']
      };

      $scope.settings.showApprovedDaysOff = $scope.state.derivedPermissions.canShowDaysOff;

      if ($scope.state.derivedPermissions.canShowDaysOff) {
        getDaysOff();
      }

      updateView();
    }

    var permissionsToLookUp = [
      'work_periods.view_unpublished',
      'availability_rules.view_in_org',
      'ui.scheduling.view_timeline' // if you can view the timeline, then we'll let you refresh the page automatically
    ];

    UserPermissionsService.getCanDict(permissionsToLookUp, $scope.org.id)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        processRawPermissions();
      });


    $scope.nextDayDate = {date: moment($scope.currentDate).add(1,'days').format('YYYY-MM-DD')};
    $scope.previousDayDate = {date: moment($scope.currentDate).subtract(1, 'days').format('YYYY-MM-DD')};

    $scope.goNextDay = function() {
      var path = '/deploymentSheet/' + $scope.nextDayDate.date;
      if ($scope.settings.showUnpublished) {
        path += '?showUnpublished=true';
      }
      $location.url(path);
    };

    $scope.goPreviousDay = function() {
      var path = '/deploymentSheet/' + $scope.previousDayDate.date;
      if ($scope.settings.showUnpublished) {
        path += '?showUnpublished=true';
      }
      $location.url(path);
    };

    var lastRefreshSettings;
    var workPeriodIntervalPromise, daysOffIntervalPromise;

    var removeWorkPeriod = function(wp) {
      _.each($scope.workPeriodsByPositionId, function(workPeriods, posId) {
        var idx = _.findIndex(workPeriods, {id: wp.id});

        if (idx > -1) {

        }
      });
    };

    var updateView = function() {
      if ($scope.settings.selectedDepartment > -1) {
        $scope.filteredDepartments = [_.find($scope.departments, {id: $scope.settings.selectedDepartment})];
      } else {
        $scope.filteredDepartments = $scope.departments;
      }

      if (!_.isUndefined(workPeriodIntervalPromise)) {
        $interval.cancel(workPeriodIntervalPromise);
      }

      if (!_.isUndefined(daysOffIntervalPromise)) {
        $interval.cancel(daysOffIntervalPromise);
      }

      if ($scope.settings.autoRefresh) {
        if ($scope.state.derivedPermissions && $scope.state.derivedPermissions.canAutoReloadPage && $scope.state.derivedPermissions.canShowDaysOff) {
          daysOffIntervalPromise = $interval(function() {
            AvailabilityRules.getRecentlyUpdatedOrNewDaysOff({recent_since: moment($scope.nowTime).subtract(10, 'seconds').format()})
              .then(function(daysOff) {

                _.each(daysOff, function(dayOff) {
                  dayOff = processDayOff(dayOff);

                  var idx = _.findIndex($scope.approvedDaysOff, {id: dayOff.id});

                  if (!dayOff.active) {
                    // remove matching dayOff from $scope.daysOff
                    if (idx > -1) {
                      $scope.approvedDaysOff.splice(idx, 1);
                    }
                  } else {
                    if (idx > -1) {
                      $scope.approvedDaysOff[idx] = dayOff;
                    } else {
                      $scope.approvedDaysOff.push(dayOff);
                    }
                  }
                });
              });
          }, 5 * 60 * 1000);
        }

        workPeriodIntervalPromise = $interval(function() {

          if ($scope.settings.autoRefreshFaster) {
            if ($scope.settings.autoRefreshFasterTimer >= 60 * 12) { // 60 minutes with 12 5s intervals. autoRefresh turns off after an hour
              $scope.settings.autoRefreshFasterTimer = 0;
              $scope.settings.autoRefreshFaster = false;
              updateView();
            } else {
              $scope.settings.autoRefreshFasterTimer += 1;
            }
          }

          //var twix = TimeService.getWeekTwixFromMoment(theDate, 1, 0);
          var data = {
            start_time: moment($scope.nowTime).format(),
            //end_time: twix.end.format(),
            recent_since: moment($scope.nowTime).subtract(10, 'seconds').format(),
            organization_id: $scope.me.memberships[0].organization.id,
            mode: 'recent_new_or_updated'
          };

          WorkPeriods.getAll(data, true)
              .then(function(results) {
                //returns an array of workPeriods that are new or that have been modified
                _.forEach(results, function(wp) {
                  var oldWpEntry = false; // used to denote if the user_id of a wp has changed;

                  var wpObj = WorkPeriods.initWithData(wp);

                  if (wpObj.$isAssigned()) {
                    var matchingIndex = _.findIndex($scope.allWorkPeriods, {id: wp.id});
                    if (matchingIndex > -1) {
                      oldWpEntry = _.cloneDeep($scope.allWorkPeriods[matchingIndex]);

                      $scope.allWorkPeriods[matchingIndex] = wpObj;
                    } else {
                      $scope.allWorkPeriods.push(wpObj);
                    }
                    WorkPeriodStore.updateOrAdd(wpObj);

                    //Now, remove the old WorkPeriod
                    removeWorkPeriod(wpObj);
                  }
                });

                //updateWorkPeriodObjects();
                $scope.nowTime = TimeService.getNowInStoreTime();

                if (results.length > 0) {
                  updateWorkPeriodObjects();
                  createRowsWithData(NUM_COLS_IN_ROW);

                }
              }, function() {
                console.log('load failed');
              });
        }, $scope.settings.autoRefreshFaster ? 5000 : 60 * 1000);
      } else {
        console.log('break that promise');
        if (!_.isUndefined(workPeriodIntervalPromise)) {
          $interval.cancel(workPeriodIntervalPromise);
        }
      }

      $rootScope.printControllerLoaded = true;

      createRowsWithData();
    };

    var createRowsWithData = function(numCols) {
      //console.log('numCols', numCols);
      $scope.dataByRow = [];
      var currColCounter = 0;
      var rowCounter = -1;

      _.each($scope.filteredDepartments, function(dept, idd) {
        _.each(dept.positions, function(pos, idp) {
          if (currColCounter === numCols || idp === 0) {
            rowCounter += 1;
            currColCounter = 0;
          }

          if (currColCounter === 0) {
            $scope.dataByRow.push({
              items: [],
              cssClasses: {
                department_row_start: idp === 0 && idd > 0
              }
            });
          }

          //console.log('rowCounter: ', rowCounter, '  currColCounter: ', currColCounter);
          $scope.dataByRow[rowCounter].items.push({
            position: pos,
            department: dept,
            workPeriods: _.sortBy($scope.workPeriodsByPositionId[pos.id], '_startTimeUnix'),
            cssClasses: {}
          });
          currColCounter += 1;
        });
      })
    };

    var updateWorkPeriodObjects = function() {
      $scope.filteredWorkPeriods = _.where($scope.allWorkPeriods, function(wp) {
        return wp.active && wp.$isAssigned() &&
            ($scope.settings.showUnpublished || wp.$isPublished());
      });


      _.each($scope.workPeriodsByPositionId, function(val, key) {
        $scope.workPeriodsByPositionId[key] = [];
      });

      _.each($scope.filteredWorkPeriods, function(wpObj) {
        if (wpObj.active && $scope.currentTwix.contains(wpObj.start_time)) {
          $scope.workPeriodsByPositionId[wpObj.position_id].push(wpObj);
        }
      });
    };

    updateWorkPeriodObjects();

    updateView();
    createRowsWithData(NUM_COLS_IN_ROW);

    $scope.openSettings = function() {
      var modalInstance = $uibModal.open({
        keyboard: false,
        size: 'md',
        templateUrl: 'views/printSettings.html',
        controller: ['$scope', '$uibModalInstance', 'params', function($scope, $uibModalInstance, params) {
          $scope.me = params.me;
          $scope.settings = _.cloneDeep(params.settings);

          if ($scope.settings.printPortrait === true) {
            $scope.settings.printPortrait = 'true';
          } else {
            $scope.settings.printPortrait = 'false';
          }

          $scope.state = {
            derivedPermissions: params.derivedPermissions
          };

          $scope.close = function() {
            $uibModalInstance.close($scope.settings);
          };

          $scope.showUnpublishedSetting = params.showUnpublishedSetting;
          $scope.showApprovedDaysOffSetting = params.showApprovedDaysOffSetting;
          $scope.showPageOrientationSetting = params.showPageOrientationSetting;

          var showNoDepartmentArea = _.any($scope.positionsToShow, {department_id: null});

          $scope.selectDepartments = _.cloneDeep(params.departments);
          if (_.findIndex($scope.selectDepartments, {id: -1}) === -1) {
            $scope.selectDepartments.push({
              id: -1,
              name: 'All Departments'
            });
          }

          if (!showNoDepartmentArea) {
            _.remove($scope.selectDepartments, {id: null});
          }

          if (_.any($scope.selectDepartments, function(dept) {
            return !_.isNull(dept.id) && dept.id > -1;
          })) {
            $scope.showDepartmentSelect = true;
          }

          $scope.$watch('settings.autoRefresh', function() {
            if ($scope.settings.autoRefresh === false) {
              $scope.settings.autoRefreshFaster = false;
              $scope.settings.autoRefreshFasterTimer = 0;
            }
          });
        }],
        resolve: {
          params: function() {
            return {
              me: $scope.me,
              settings: $scope.settings,
              departments: $scope.departments,
              showUnpublishedSetting: true,
              showApprovedDaysOffSetting: true,
              showPageOrientationSetting: true,
              showGroupByDepartmentSetting: false,
              derivedPermissions: $scope.state.derivedPermissions
            };
          }
        }
      });

      modalInstance.result.then(function(result) {
        lastRefreshSettings = $scope.settings.autoRefresh ? 1 : 0 + $scope.settings.autoRefreshFaster ? 1 : 0;
        result.printPortrait = result.printPortrait === 'true';

        $scope.settings = result;
        storePrintSettings();


        if (result.printPortrait) {
          NUM_COLS_IN_ROW = 3;
          $('.standard_print_container').removeClass('landscape');
          $('.standard_print_container').addClass('portrait');
        } else {
          NUM_COLS_IN_ROW = 4;
          $('.standard_print_container').addClass('landscape');
          $('.standard_print_container').removeClass('portrait');
        }
        updateWorkPeriodObjects();
        updateView();
        createRowsWithData(NUM_COLS_IN_ROW);
      });
    };

    var storePrintSettings = function() {
      var attributes = ['autoRefresh',
        'showApprovedDaysOff', 'printPortrait'];

      var storedSettings = Session.getPrintSettings();
      if (_.isNull(storedSettings) || _.isUndefined(storedSettings)) {
        storedSettings = {};
      }

      if (!_.has(storedSettings, 'deployment')) {
        storedSettings['deployment'] = {};
      }

      _.each(attributes, function(attr) {
        storedSettings['deployment'][attr] = $scope.settings[attr];
      });

      Session.setPrintSettings(storedSettings);
    };

  });
